export default function SupplierReportCards() {
  return (
    <div className="animate-slide-up">
      <div className="page-header">
        <h1 className="page-title">Supplier Report Cards</h1>
        <p className="page-subtitle">Evaluate and compare supplier performance.</p>
      </div>
      <p className="text-muted-foreground">Coming soon.</p>
    </div>
  );
}
